import PayPalSubscribeButton from './PayPalSubscribeButton';
import { KiddiFitWordmark } from './Brand';

export default function PremiumSubscribe() {
  return (
    <div style={{ padding: 16 }}>
      <div style={{ fontSize: 24, fontWeight: 700 }}><KiddiFitWordmark />™</div>
      <h2>Premium Subscription</h2>
      <p>Access all the premium features including the full Skill Library. Thank you for your support.</p>
      <div style={{ margin: '16px 0' }}>
        <PayPalSubscribeButton />
      </div>
      <div style={{ color: '#666', fontSize: 12 }}>Cancel anytime, no questions asked.</div>
    </div>
  );
}


